import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgBetaalmanier = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#A8D3AF"
      d="M29.26 9.27H6.74A1.74 1.74 0 0 0 5 11.01v12.52c0 .961.779 1.74 1.74 1.74h22.52A1.74 1.74 0 0 0 31 23.53V11.01a1.74 1.74 0 0 0-1.74-1.74"
    />
    <path
      fill="#00A75D"
      d="M16.67 17.6h-10v1h10zM31 11.98H5v2.56h26zM29.2 32.47l1.98.8 2.02-2.02-.85-2.14.67-1.15 1.97-.83v-2.86l-2.11-.91-.34-1.29.8-1.98-2.02-2.02-2.14.85-1.15-.67-.83-1.97h-2.86l-.91 2.11-1.29.34-1.98-.8-2.02 2.02.85 2.14-.67 1.15-1.97.83v2.86l2.11.91.34 1.29-.8 1.98 2.02 2.02 2.14-.85 1.15.67.83 1.97H27l.91-2.11zm-6.41-6.88a2.87 2.87 0 0 1 2.87-2.87c1.58 0 2.87 1.29 2.87 2.87s-1.29 2.87-2.87 2.87-2.87-1.29-2.87-2.87M12.56 20.71H6.67v1h5.89z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgBetaalmanier);

export default ForwardRef;
